var React = require('react');

function ExclamationCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"}));
}

ExclamationCircle.defaultProps = {"fill":"none","viewBox":"0 0 24 24","strokeWidth":"1.5","stroke":"currentColor","className":"size-6"};

module.exports = ExclamationCircle;

ExclamationCircle.default = ExclamationCircle;
